import { ConfigStore as BaseConfigStore } from '@engineering11/config-web'
import { CnectConfig, CnectFeatures, CnectListenConfig } from '../config'

export const ConfigStore = BaseConfigStore
export type ConfigStore = BaseConfigStore<CnectConfig, CnectListenConfig, CnectFeatures>
